import { track } from '@ramp106/omrjs-tracking-reviews'
import { useI18n } from 'vue-i18n'

import { type LeadStatusEnum, useSetReviewsLeadStatusMutation } from '@/gql/reviews'
import { showNotification } from '@/helpers/notificationHelper'

const mutationOptions = {
  clientId: 'reviews',
  refetchQueries: ['reviewsLead', 'reviewsLeads'],
  awaitRefetchQueries: true,
}

export function useLeadStatus() {
  const { t } = useI18n()
  const { mutate, loading } = useSetReviewsLeadStatusMutation(mutationOptions)

  async function setStatus(leadId: string, status: LeadStatusEnum): Promise<void> {
    track('cta_click', {
      surface: 'cta',
      category: 'meaningful_action',
      cta_id: `lead_status_${status}`,
      cta_position: 'lead_detail',
    })

    try {
      await mutate({ id: leadId, status })
      showNotification(t('Leads.status.updated'), 'success')
    } catch {
      showNotification(t('Leads.status.errorNotification'), 'error', 10000)
    }
  }

  return { setStatus, loading }
}
